import Landing from './Landing'
import './App.scss';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Landing></Landing>
      </header>
    </div>
  );
}

export default App;
